import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  EventEmitter,
  HostListener,
  inject,
  input,
  InputSignal,
  Output
} from '@angular/core';
import { SzButtonComponent } from '../../controls/sz-button/sz-button.component';

const BODY_LOCK_CLASS: string = 'sz-body-scroll-lock';

@Component({
  selector: 'sz-confirm-dialog',
  templateUrl: './sz-confirm-dialog.component.html',
  styleUrls: ['./sz-confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzButtonComponent]
})
export class SzConfirmDialogComponent {
  readonly open: InputSignal<boolean> = input<boolean>(false);
  readonly header: InputSignal<string> = input<string>('');
  readonly message: InputSignal<string> = input<string>('');
  readonly okLabel: InputSignal<string> = input<string>('Potwierdź');
  readonly cancelLabel: InputSignal<string> = input<string>('Anuluj');
  readonly destructive: InputSignal<boolean> = input<boolean>(false);
  readonly dismissOnScrim: InputSignal<boolean> = input<boolean>(true);
  readonly dismissOnEsc: InputSignal<boolean> = input<boolean>(true);

  @Output() readonly confirm: EventEmitter<void> = new EventEmitter<void>();
  @Output() readonly cancel: EventEmitter<void> = new EventEmitter<void>();

  private readonly document: Document = inject(DOCUMENT);

  constructor() {
    effect((): void => {
      const isOpen: boolean = this.open();
      this.document.body.classList.toggle(BODY_LOCK_CLASS, isOpen);
    });
  }

  onScrimClick(): void {
    if (this.dismissOnScrim()) {
      this.cancel.emit();
    }
  }

  onConfirm(): void {
    this.confirm.emit();
  }

  onCancel(): void {
    this.cancel.emit();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.open() && this.dismissOnEsc()) {
      this.cancel.emit();
    }
  }
}
